// DS: i6.15
import React from 'react';
import IconWrap from '../../IconWrap';
const AddGallery = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M4 5v14h16v1a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h1zm17-2a1 1 0 01.993.883L22 4v13a1 1 0 01-.883.993L21 18H6a1 1 0 01-.993-.883L5 17V4a1 1 0 01.883-.993L6 3h15zm-1 2H7v11h3.271l5.608-5.607a1 1 0 011.414 0L20 13.1V5zm-9.5 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
        fillRule: "evenodd"
    })));
};
AddGallery.displayName = 'AddGallery';
export default AddGallery;
